// extracted by mini-css-extract-plugin
module.exports = {"mCard":"Ta","image":"Ua","imageNoBackground":"Va"};